import { render, staticRenderFns } from "./ApproverStateInput.vue?vue&type=template&id=fab3a978&scoped=true&"
import script from "./ApproverStateInput.vue?vue&type=script&lang=js&"
export * from "./ApproverStateInput.vue?vue&type=script&lang=js&"
import style0 from "./ApproverStateInput.vue?vue&type=style&index=0&id=fab3a978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab3a978",
  null
  
)

export default component.exports